{
    "chooseDevice": {
        "brand": "Бренд",
        "category": "Категорія",
        "color": "Колір",
        "cpu": "Процесор",
        "deviceNotAccepted": "На жаль цей пристрій не приймається",
        "gpu": "Відеокарта",
        "memory": "Накопичувач",
        "model": "Модель",
        "other": "Пам'ять / Модель / Рік",
        "ram": "Оперативна пам'ять",
        "subtitle": "Вкажіть модель, щоб дізнатися розмір вигоди",
        "title": "Який пристрій ви хочете здати?"
    },
    "common": {
        "back": "Повернутись",
        "close": "Закрити",
        "continue": "Продовжити",
        "error": "Щось пішло не так. Спробуйте ще раз.",
        "restart": "Почати заново"
    },
    "grades": {
        "A": "Відмінний",
        "B": "Гарний",
        "C": "Зі слідами експлуатації",
        "D": "Зі значними слідами експлуатації",
        "E": "Критичний",
        "Q": "Ідеальний"
    },
    "handedDevice": {
        "edit": "Змінити пристрій",
        "title": "Пристрій, що здається",
        "valuation": "Оцінка пристрою"
    },
    "leaveContacts": {
        "priceNote": "Ціни дійсні 14 робочих днів та фінальна ціна викупу буде відома тільки після фізичної діагностики.",
        "title": "Попередня ціна"
    },
    "requestBuyoutOffer": {
        "companyName": "Назва компанії",
        "consent": "Я погоджуюсь на обробку моїх персональних даних згідно {link}",
        "consentLink": "Закону України “Про захист персональних даних”",
        "email": "Email",
        "emailInvalid": "Вкажіть коректний email",
        "firstName": "Ім’я",
        "lastName": "Прізвище",
        "optional": "необов’язково",
        "phone": "Телефон",
        "phoneInvalid": "Вкажіть номер з кодом країни, від 9 до 15 цифр",
        "subtitle": "Залиште контакти, щоб наш менеджер міг підготувати для вас пропозицію щодо викупу",
        "title": "Дізнайтеся, скільки коштує вся техніка вашої компанії"
    },
    "select": {
        "notFound": "Вибачте. Збігів не знайдено."
    },
    "thanksForOrder": {
        "sendAnother": "Надіслати ще один запит",
        "text": "Наш менеджер розрахує вартість техніки та зв'яжеться з вами. Дякуємо, що продовжуєте життя техніки! ☘️",
        "title": "Готово! Ваш запит надіслано."
    },
    "uploadDevicesList": {
        "chooseFile": "Завантажте файл",
        "downloadTemplate": "Скачати шаблон списку пристроїв",
        "dropHere": "Перетягніть файл сюди",
        "invalidFormat": "Підтримується лише формат XLSX",
        "or": "або",
        "removeFile": "Видалити файл",
        "submit": "Отримати пропозицію щодо викупу",
        "subtitle": "Завантажте файл з переліком пристроїв у форматі XLSX або використовуйте шаблон для заповнення",
        "title": "Завантажте список пристроїв для перевірки"
    }
}
